export namespace HsToolsConstants {
  export const SPEED_FACTOR: number = 0.5;
  export const FOCUS_POINT_DISTANCE: number = 10;
  export const MOUSE_MOVE_ROTATE_FACTOR: number = 0.0125;
  // World units the default camera tool pans per pixel of a middle-button drag.
  export const PAN_UNITS_PER_PIXEL: number = SPEED_FACTOR * 0.3;
  export const MAX_CAMERA_ANGLE: number = Math.PI / 2;
  export const MIN_CAMERA_ANGLE: number = -MAX_CAMERA_ANGLE;
  // Zoom steps never shrink below this distance, so a zoom can still push through a surface it touches.
  export const ZOOM_MIN_DISTANCE: number = 1;
  // Distance used for zoom steps when nothing under the zoom point gives a better estimate.
  export const ZOOM_FALLBACK_DISTANCE: number = FOCUS_POINT_DISTANCE;
}
